import React from 'react';
import { Link } from 'react-router';
import { enlaceConfigurarAgenda } from '../../lib/citasApi';

/**
 * AVISO DE LAS AGENDAS QUE ABREN DE LUNES A VIERNES SIN REVISAR, en la vista
 * «Mes» de la Agenda (dirección, 15/10/2026: «pon aviso ajustar/seleccionar
 * horario agendas»).
 *
 * Casi todas las agendas abren los cinco días laborables (con el horario con
 * que nacieron o con variantes de horas), y el Mes las da como abiertas
 * todos los días laborables. Si alguna de las agendas que se están viendo
 * abre de lunes a viernes y nadie ha revisado su horario
 * (`horario_por_revisar`, lo calcula el servidor: backend/services/
 * horario_agenda.py), sale este aviso encima del mes.
 *
 * Quien puede configurar agendas (`puedeConfigurar`: admin, como Configurar
 * agenda) ve además «Ajustar horarios ▸» (Gestión de agendas) y la lista de
 * esas agendas, cada una con su enlace a «Configurar». Quien no, el aviso sin
 * enlaces de configuración.
 *
 * Props:
 *  - agendas: las que se están viendo;
 *  - puedeConfigurar.
 */
export default function AvisoHorarioSinRevisar({ agendas = [], puedeConfigurar = false }) {
  const porRevisar = agendas.filter((a) => a?.horario_por_revisar);
  const n = porRevisar.length;
  if (!n) return null;
  const una = n === 1;
  return (
    <div
      role="note"
      className="mb-3 rounded-lg border border-amber-300/80 bg-amber-50 px-3 py-2 text-sm text-[#13231E] dark:border-amber-700/60 dark:bg-amber-950/30 dark:text-amber-50"
      data-testid="aviso-horario-sin-revisar"
      data-agendas={n}
    >
      <p className="leading-snug">
        <span data-testid="aviso-horario-sin-revisar-texto">
          {n} {una ? 'agenda abre' : 'agendas abren'} de lunes a viernes sin revisar: el Mes{' '}
          {una ? 'la da como abierta' : 'las da como abiertas'} todos los días laborables.
        </span>
        {puedeConfigurar ? (
          <>
            {' '}
            <Link
              to="/gestion-agendas"
              className="font-medium text-[#2E6E5E] underline-offset-2 hover:underline dark:text-amber-200 whitespace-nowrap"
              data-testid="aviso-horario-ajustar"
            >
              Ajustar horarios ▸
            </Link>
          </>
        ) : (
          <span className="text-[#13231E]/75 dark:text-amber-100/80">
            {' '}Lo ajusta un administrador en Gestión de agendas.
          </span>
        )}
      </p>
      {puedeConfigurar && (
        <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1">
          <span className="text-xs text-[#13231E]/75 dark:text-amber-100/80">Configurar:</span>
          <ul className="flex flex-wrap gap-1.5" data-testid="aviso-horario-lista">
            {porRevisar.map((a) => (
              <li key={a.id} className="min-w-0">
                <Link
                  to={enlaceConfigurarAgenda(a.id)}
                  className="inline-flex max-w-full items-center gap-1.5 rounded-full border border-amber-300/80 bg-white px-2 py-0.5 text-xs text-[#13231E] hover:border-[#2E6E5E] dark:border-amber-700/60 dark:bg-transparent dark:text-amber-50"
                  title={`Configurar el horario de «${a.name}»`}
                  aria-label={`Configurar el horario de ${a.name}`}
                  data-testid={`aviso-horario-configurar-${a.id}`}
                >
                  <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: a.color || '#2E6E5E' }} aria-hidden="true" />
                  <span className="truncate">{a.name}</span>
                  <span aria-hidden="true">▸</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
